import { SsoType, } from '@tribeplatform/gql-client/types';
import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSsosKey } from '../../utils/keys';
export const useUpdateJwtSso = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const ssosKey = getSsosKey();
    return useMutation((input) => client.auth.updateJwtSso(input), {
        onMutate: async (updatedJwtSso) => {
            await queryClient.cancelQueries(ssosKey);
            const snapshot = queryClient.getQueryData(ssosKey);
            queryClient.setQueriesData(ssosKey, old => [
                ...old === null || old === void 0 ? void 0 : old.filter(sso => sso.type !== SsoType.JWT),
                { ...old === null || old === void 0 ? void 0 : old.find(sso => sso.type === SsoType.JWT), ...updatedJwtSso },
            ]);
            return { snapshot };
        },
        onSuccess: updatedJwtSso => {
            queryClient.setQueryData(ssosKey, old => [
                ...old === null || old === void 0 ? void 0 : old.filter(sso => sso.type !== SsoType.JWT),
                { ...old === null || old === void 0 ? void 0 : old.find(sso => sso.type === SsoType.JWT), ...updatedJwtSso },
            ]);
        },
        onError: (_, __, context) => {
            queryClient.setQueryData(ssosKey, context.snapshot);
            queryClient.invalidateQueries(ssosKey);
        },
        onSettled: () => {
            queryClient.invalidateQueries(ssosKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateJwtSso.js.map